type TypeProps = {
  balance: string;
  name: string;
  project_id: string;
  starts_at: string;
  token_amount: string;
  stages: {
    [key: string]: string;
  };
};

import GridTable from 'components/grid-table/grid-table';
import { columnsRetireActivity } from 'utils/columns-table';

import { useAppSelector } from 'redux/use-hooks';
import { selectAccountId } from 'redux/slices/account';
import {
  sendQueryNFTProjects,
  useQueryNftMetadata
} from 'lib/hooks/use-query-nft-metadata';

import { StyledHeading } from 'assets/styles/pages.style';
import {
  StyledEmptyText,
  StyledItemsEmpty
} from '../grid-table/grid-table.style';

const RetireActivityTable = () => {
  const accountId = useAppSelector(selectAccountId);

  const { tokens: projects, isLoading, isLoadingMore, hasMore } = useQueryNftMetadata(accountId, sendQueryNFTProjects);

  return (
    <>
      <StyledHeading>Retirement Activity</StyledHeading>
      <GridTable<TypeProps>
        uniqueKey="offset-activity"
        variant="offset-activity"
        loading={isLoading}
        columns={columnsRetireActivity}
        componentEmpty={
          <StyledItemsEmpty>
            <StyledEmptyText>No activity</StyledEmptyText>
          </StyledItemsEmpty>
        }
        isLoading={isLoadingMore}
        hasMore={hasMore}
        data={projects}
        defaultSort={{ key: 'starts_at', direction: 'descending' }}
      />
    </>
  );
};

export default RetireActivityTable;
